import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from '../config/api';

import OfferModal from "../components/OfferModal";
import "../pages/Offers.css";

const EventOffer = ({
  title = "Offers for you",
  showSeeAll = true,
  seeAllLabel = "See All",
  seeAllHref = "/offers",
}) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchHomeOffers = async () => {
      try {
        setLoading(true);
        const data = await api.getHomeOffers(); // GET /api/offers/home — only show_in_home=true
        setOffers(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching home offers:", err);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHomeOffers();
  }, []);

  const openOffer = (offer) => {
    setSelectedOffer(offer);
    setShowModal(true);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  // Nothing to show — section disappears entirely
  if (!loading && offers.length === 0) return null;

  return (
    <>
      <section className="offers-section">
        <div className="container">
          <div className="offers-section-header">
            <h2 className="offers-section-title">{title}</h2>
            {showSeeAll && (
              <Link to={seeAllHref} className="offers-see-all">
                {seeAllLabel} <span className="offers-see-all-chevron">›</span>
              </Link>
            )}
          </div>

          {loading ? (
            <div className="offers-grid">
              {[1, 2, 3].map(i => (
                <div key={i} className="offer-skeleton">
                  <div className="sk-offer-img"></div>
                  <div className="sk-offer-body">
                    <div className="sk-offer-title"></div>
                    <div className="sk-offer-sub"></div>
                    <div className="sk-offer-btn"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="offers-grid">
              {offers.map((offer) => (
                <div className="offer-card" key={offer.id}>
                  <div className="offer-image-wrapper">
                    <img
                      src={offer.listing_image}
                      alt={offer.title}
                      className="offer-image"
                    />
                  </div>
                  <div className="offer-content">
                    <h5>{offer.title}</h5>
                    <div className="offer-footer">
                      {offer.end_date && (
                        <p className="offer-validity">
                          Valid till: <span>{formatDate(offer.end_date)}</span>
                        </p>
                      )}
                      <button className="offer-btn" onClick={() => openOffer(offer)}>
                        View
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>

      <OfferModal
        show={showModal}
        offer={selectedOffer}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default EventOffer;